<div class="row">
    <ngx-nebular-select></ngx-nebular-select>
</div>
